/** One screen: a header, optional tabs, then panels at one rhythm inside one measure. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import { PageHeader } from "../PageHeader/PageHeader";
import "./Page.css";

export interface PageProps {
  readonly title: ReactNode;
  readonly eyebrow?: ReactNode;
  readonly actions?: ReactNode;
  readonly tabs?: ReactNode;
  /** `wide` for a table-heavy screen, `narrow` for a single form. */
  readonly measure?: "default" | "wide" | "narrow" | "full";
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function Page({
  title,
  eyebrow,
  actions,
  tabs,
  measure = "default",
  className,
  style,
  children,
}: PageProps) {
  return (
    <div className={cn("al-page", `al-page-${measure}`, className)} style={style}>
      <PageHeader title={title} eyebrow={eyebrow} actions={actions} />
      {tabs !== undefined ? <div className="al-page-tabs">{tabs}</div> : null}
      <div className="al-page-body">{children}</div>
    </div>
  );
}
